/* src/app/modules/shared/components/column/column-top-flavor/column-top-flavor.component.scss */
app-column-top-flavor {
  display: contents;
}
/*# sourceMappingURL=column-top-flavor.component.css.map */
